import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UnauthorisedPerson } from "../auth/unauthorised-person";
import { PortalSideMenu } from "../side-menu";

export const PortalMainLayout = ({
  title,
  children,
  isUnauthorised,
  printTitle = true,
}) => {
  const { pathname } = useLocation();
  return (
    <div className="relative min-h-screen bg-black text-white">
      <FadeSideMenu showSideMenu={typeof window !== 'undefined' ? window.__hideSideMenu !== true : true} />

      <main
        key={pathname}
        className={["container-fluid", "pb-[calc(96px_+_env(safe-area-inset-bottom,0px))] min-[880px]:pb-10", "max-h-[100vh] overflow-y-auto", "screen-fade"].join(" ")}
      >
        {title ? (
          <div className={printTitle ? "" : "print:hidden"}>
            <h1 className="text-center font-headings-primary font-medium text-[28px] leading-[33.6px] mb-4 tracking-wide">{title}</h1>
          </div>
        ) : null}

        <section className="mt-3">
          {isUnauthorised ? (
            <UnauthorisedPerson show={true} />
          ) : (
            <div>{children}</div>
          )}
        </section>
      </main>
    </div>
  );
};

function FadeSideMenu({ showSideMenu }) {
  const [sideMenuVisible, setSideMenuVisible] = useState(typeof window !== 'undefined' ? window.__hideSideMenu !== true : true);
  const [fadeVisible, setFadeVisible] = useState(sideMenuVisible);

  useEffect(() => {
    const interval = setInterval(() => {
      const current = typeof window !== 'undefined' ? window.__hideSideMenu !== true : true;
      setSideMenuVisible(current);
    }, 200);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (sideMenuVisible) setFadeVisible(true);
    else setTimeout(() => setFadeVisible(false), 300);
  }, [sideMenuVisible]);

  return (
    <div
      style={{
        transition: "opacity 0.3s",
        opacity: sideMenuVisible ? 1 : 0,
        pointerEvents: sideMenuVisible ? "auto" : "none",
        position: "absolute",
        left: 0,
        top: 0,
        height: "100%",
        zIndex: 1000,
        width: fadeVisible ? undefined : 0,
      }}
    >
      {fadeVisible && <PortalSideMenu asSideMenu={true} />}
    </div>
  );
}
